export default {
	message: 'Вы уверены, что сохранили ключи в надежном месте?',

	submit: 'Да, я сохранил',
	cancel: 'Назад',
}
